const styles = {
  headerStyles: {
    alignItems: 'center',
    bg: 'var(--ql-color-accent1)',
    color: 'var(--ql-typography-text-color-primary-reverse)'
  }
}

export { styles }
